<template>
    <div class="profile-page">
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section section-hero section-shaped my-0" >
                <div class="shape shape-primary shape-skew alpha-4">
                    
                </div>
                <div class="container shape-container d-flex align-items-center py-lg" style="margin-top:100px !important">
                    <div class="col px-0">
                        <div class="row align-items-center justify-content-center">
                            <div class="col-lg-6 text-center">
                                <!-- <h1 class="display-3  text-dark">Welcome to</h1> -->
                                <div class="card-profile-image" >
                                    <a href="#">
                                        <img v-lazy="'img/theme/profile_main.png'" class="rounded-circle" style="height:250px">
                                    </a>
                                </div>
                                <h1 class="display-1  text-white" style="font-family: 'League Spartan', sans-serif;">ragini sinha</h1>
                                <h6 class="text-white mt-3 display-4" style="font-family: 'League Spartan', sans-serif;">Certified Coach</h6>
                            </div>
                        </div>
                        <div class="row align-items-center justify-content-center">
                            <div class="col-lg-12 text-center">
                                <card shadow class="card-profile" no-body style="margin-top:00px !important">
                                    <div class="px-4">                      
                                        <div class="py-5 text-center">
                                            <div class="row justify-content-center">
                                                <div class="col-lg-9">
                                                    <p class="text-justify" style="font-weight: 400;">There are times when we feel stuck, uncertain and non decisive. If you are looking to navigate through these swarms of thoughts, let us talk. I am here to support you and build a safe space for all your thoughts to float. Let us focus on your “here and now”. <br><br>I am Ragini, a certified coach with a passion for collaborating with individuals and groups towards overcoming personal and professional challenges.  </p>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <!-- <section class="section section-skew" style="background-image : url('img/custom/whatweoffer.svg')">
            <div class="container">
                <card shadow class="card-profile" no-body style="margin-top:-400px !important">
                    <div class="px-4">                      
                        <div class="py-5 text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-9">
                                    <p class="text-justify" style="font-weight: 400;">There are times when we feel stuck, uncertain and non decisive. If you are looking to navigate through these swarms of thoughts, let us talk. I am here to support you and build a safe space for all your thoughts to float. Let us focus on your “here and now”. <br><br>I am Ragini, a certified coach with a passion for collaborating with individuals and groups towards overcoming personal and professional challenges.  </p>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section> -->
        <section class="section section-lg pt-lg-0 mt-5" style="background-image : url('img/custom/whatweoffer.svg')">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 mx-auto text-center">
                        <h2 class="display-3">What we can talk about?</h2>
                    </div>
                </div>
                <div class="row justify-content-center mt-5">
                    <div class="col-lg-12">
                        <div class="row row-grid justify-content-center">

                            <div class="col-lg-4">
                                <card class="border-0 text-center" hover shadow body-classes="py-5">
                                    <img src="img/theme/home-icon-001.png" class="img-fluid floating" style="width : 50%">                                    
                                    <h6 class="info-title text-primary text-uppercase mt-3"><b>PERSONAL DEVELOPMENT</b></h6>
                                    <!-- <p class="description mt-3">
                                        Android App Development<br>
                                        iOS App Development<br>
                                        Flutter App Development
                                    </p>
                                    <div>
                                        <badge type="primary" rounded>Basic</badge>
                                        <badge type="primary" rounded>Impactful</badge>
                                        <badge type="primary" rounded>Solution</badge>
                                    </div>
                                    <base-button tag="a" href="/services" type="primary" class="mt-4">
                                        Learn more
                                    </base-button> -->
                                </card>
                            </div>

                            <div class="col-lg-4">
                                <card class="border-0 text-center" hover shadow body-classes="py-5">
                                    <img src="img/theme/home-icon-002.png" class="img-fluid floating " style="width : 50%">
                                    <h6 class="info-title text-success text-uppercase mt-3"><b>CAREER ADVANCEMENT</b></h6>                                    
                                </card>
                            </div>

                            <div class="col-lg-4">
                                <card class="border-0 text-center" hover shadow body-classes="py-5">
                                    <img src="img/theme/home-icon-003.png" class="img-fluid floating " style="width : 50%">
                                    <h6 class="info-title text-warning text-uppercase mt-3"><b>LEADERSHIP SKILLS</b></h6>
                                </card>
                            </div>

                            <div class="col-lg-4 mt-5">
                                <card class="border-0 text-center" hover shadow body-classes="py-5">
                                    <img src="img/theme/home-icon-004.png" class="img-fluid floating" style="width : 50%">
                                    <h6 class="info-title text-warning text-uppercase mt-3"><b>GOAL SETTING & ACHEIVEMENTS</b></h6>                                    
                                </card>
                            </div>

                            <div class="col-lg-4 mt-5">
                                <card class="border-0 text-center" hover shadow body-classes="py-5">
                                    <img src="img/theme/home-icon-005.png" class="img-fluid floating " style="width : 50%">
                                    <h6 class="info-title text-primary text-uppercase mt-3"><b>MINDFULNESS & WELL BEING</b></h6>                                    
                                </card>
                            </div>                                  
                        </div>
                    </div>
                </div>
            </div>
        </section>        
    </div>
</template>
<script>
export default {};
</script>
<style>
</style>
